import axios from 'axios';
import config from './../config';

const api = axios.create({baseURL: config.apiGateway.URL});

api.interceptors.request.use(async (configRequest) => {
  const token = localStorage.getItem('@pes-backend');
  const config = configRequest;
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;
